import { Box, BoxProps } from '@material-ui/core';

const Flex = (props: BoxProps): React.ReactElement => <Box display="flex" {...props} />;

export default Flex;
